// TODO: Support all these file types (and corresponding file sizes)
// https://docs.github.com/en/get-started/writing-on-github/working-with-advanced-formatting/attaching-files

export const imageTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/webp",
  "image/svg+xml",
] as const
export const videoTypes = [
  "video/mp4",
  "video/quicktime",
  "video/webm",
] as const
export const documentTypes = ["application/pdf"] as const
export const allTypes = [
  ...imageTypes,
  ...videoTypes,
  ...documentTypes,
] as const

export type ContentType = (typeof allTypes)[number]

export const imageMaxSize = 10 * 1024 * 1024 // 10MB
export const videoMaxSize = 10 * 1024 * 1024 // 10MB
export const documentMaxSize = 25 * 1024 * 1024 // 25MB

export function getHumanTypeName(type: ContentType) {
  if (type.startsWith("image/")) return "image"
  if (type.startsWith("video/")) return "video"
  if (documentTypes.some((documentType) => documentType === type))
    return "document"
  return
}

export function getMaxSize(type: ContentType) {
  const options = [
    { types: imageTypes, size: imageMaxSize },
    { types: videoTypes, size: videoMaxSize },
    { types: documentTypes, size: documentMaxSize },
  ]
  for (const { types, size } of options)
    if (types.includes(type as never)) return size
  return 0
}

export const extensionMap = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/svg+xml": "svg",
  "video/mp4": "mp4",
  "video/quicktime": "mov",
  "video/webm": "webm",
  "application/pdf": "pdf",
} as const satisfies Record<ContentType, string>
